import React, { useEffect, useMemo, useState } from "react";
import { getWishlistRecordsService } from "../../../services/apiService";

const CustomerWishlist = () => {
  const [wishlistData, setWishlistData] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  // ✅ Pagination states
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  // ✅ Fetch Wishlist Records
  const fetchWishlist = async () => {
    try {
      setLoading(true);
      const res = await getWishlistRecordsService();
      setWishlistData(res?.data || []);
    } catch (err) {
      console.error("Wishlist records error:", err);
      setWishlistData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchWishlist();
  }, []);

  // ✅ Search Filter (Customer ID + Customer Name only)
  const filteredData = useMemo(() => {
    if (!search) return wishlistData;

    return wishlistData.filter((row) => {
      const customerName = `${row.first_name || ""} ${row.last_name || ""}`
        .trim()
        .toLowerCase();

      const customerId = String(row.customerid || "").toLowerCase();
      const searchText = search.toLowerCase();

      return customerId.includes(searchText) || customerName.includes(searchText);
    });
  }, [wishlistData, search]);

  // ✅ Pagination calculations
  const totalPages = Math.ceil(filteredData.length / pageSize);
  const paginatedData = filteredData.slice(
    (page - 1) * pageSize,
    page * pageSize
  );

  return (
    <div style={styles.wrapper}>
      {/* Header */}
      <div style={styles.header}>
        <h2 style={styles.title}>Customer Wishlist</h2>

        <div style={styles.searchBox}>
          <span style={styles.searchIcon}>🔍</span>
          <input
            type="text"
            placeholder="Search by Customer ID / Name"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setPage(1);
            }}
            style={styles.searchInput}
          />
        </div>
      </div>

      {/* Table Box */}
      <div style={styles.tableOuter}>
        <div style={styles.tableContainer}>
          <table style={styles.table}>
            <thead>
              <tr style={styles.trHead}>
                <th style={styles.th}>Wishlist ID</th>
                <th style={styles.th}>Customer ID</th>
                <th style={styles.th}>Customer Name</th>
                <th style={styles.th}>Model No</th>
                <th style={styles.th}>Brand</th>
                <th style={styles.th}>Category</th>
                <th style={styles.th}>Sub Category</th>
                <th style={styles.th}>Mobile</th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td style={styles.noData} colSpan={8}>
                    Loading...
                  </td>
                </tr>
              ) : paginatedData.length === 0 ? (
                <tr>
                  <td style={styles.noData} colSpan={8}>
                    No Data Found
                  </td>
                </tr>
              ) : (
                paginatedData.map((row, idx) => (
                  <tr
                    key={row.id}
                    style={{
                      background: idx % 2 === 0 ? "#fff" : "#f2f2f2",
                    }}
                  >
                    <td style={styles.td}>{row.id}</td>
                    <td style={styles.td}>{row.customerid}</td>
                    <td style={styles.td}>
                      {`${row.first_name || ""} ${row.last_name || ""}`.trim() ||
                        row.username ||
                        "-"}
                    </td>
                    <td style={styles.td}>{row.modelno}</td>
                    <td style={styles.td}>{row.brand}</td>
                    <td style={styles.td}>{row.category}</td>
                    <td style={styles.td}>{row.subcategory}</td>
                    <td style={styles.td}>{row.mobile}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* ✅ Pagination */}
      
<div className="pagination-container">


<div>

Items per page:

<select
className="page-select"
value={pageSize}
onChange={(e) => {
setPageSize(Number(e.target.value));
setPage(1);
}}
>

{[5,10,20,50].map((n)=>(
<option key={n} value={n}>
{n}
</option>
))}

</select>

</div>



<div className="page-buttons">

<button
className="page-btn"
disabled={page===1}
onClick={()=>setPage(page-1)}
>
Previous
</button>


<span className="page-count">

{page} / {totalPages || 1}

</span>


<button
className="page-btn"
disabled={page===totalPages || totalPages===0}
onClick={()=>setPage(page+1)}
>
Next
</button>

</div>


</div>
      </div>
    </div>
  );
};

export default CustomerWishlist;

/* ✅ Same Inline Styles */
const styles = {
  wrapper: {
    width: "100%",
    background: "#fff",
    padding: "12px 14px",
    fontFamily: "Arial, sans-serif",
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "8px",
  },

  title: {
    margin: 0,
    color: "#0f9d58",
    fontSize: "22px",
    fontWeight: "700",
  },

  searchBox: {
    display: "flex",
    alignItems: "center",
    border: "1px solid #ddd",
    borderRadius: "6px",
    padding: "4px 10px",
    width: "220px",
    background: "#fff",
  },

  searchIcon: {
    fontSize: "14px",
    marginRight: "6px",
    color: "#0f9d58",
  },

  searchInput: {
    border: "none",
    outline: "none",
    width: "100%",
    fontSize: "14px",
  },

  tableOuter: {
    border: "1px solid #dcdcdc",
    borderRadius: "6px",
    padding: "10px",
  },

  tableContainer: {
    overflowX: "auto",
  },

  table: {
    width: "100%",
    borderCollapse: "collapse",
    minWidth: "1100px",
  },

  trHead: {
    background: "#eeeeee",
  },

  th: {
    padding: "10px",
    fontSize: "12px",
    textAlign: "left",
    borderBottom: "1px solid #ddd",
    fontWeight: "700",
  },

  td: {
    padding: "10px",
    fontSize: "12px",
    borderBottom: "1px solid #e5e5e5",
  },

  noData: {
    padding: "14px",
    textAlign: "center",
    fontSize: "14px",
  },
};
